import { faCirclePlay, faComments, faGraduationCap, faHandshake, faMobileScreen, faStairs } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const CourseHighlights = () => {
    return (
        <div className='px-4 md:px-12 my-6'>
            <h1 className='text-6xl text-blue-400 font-semibold mb-8 text-center'>Course <span className='text-orange-400'>Highlights</span></h1>
            <div className='grid grid-cols-1 md:grid-cols-2 md:gap-20 gap-4'>
                <div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faCirclePlay} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Learn Online</h1>
                            <p className=''>At your own schedule</p>
                        </div>
                    </div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer my-2'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faHandshake} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Placement Assistance</h1>
                            <p className=''>To build your career</p>
                        </div>
                    </div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faComments} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Doubt Clearing</h1>
                            <p className=''>Through Q&A forum</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faMobileScreen} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Mobile Friendly</h1>
                            <p className=''>No laptop? No problem</p>
                        </div>
                    </div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer my-2'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faGraduationCap} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Certificate of training</h1>
                            <p className=''>from internshala training</p>
                        </div>
                    </div>
                    <div className='flex pl-4 align-middle py-1 cursor-pointer'>
                        <FontAwesomeIcon className='text-5xl text-blue-500 w-20 bg-blue-100 px-6 py-4 rounded-lg' icon={faStairs} />
                        <div className='ml-6'>
                            <h1 className='text-xl font-semibold mb-2'>Beginner Friendly</h1>
                            <p className=''>No prior knowledge required</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CourseHighlights;